export const inputNumberDirective = () => {
	return {
		require: 'ngModel',
		restrict: 'A',
		link: (scope, element, attrs, ngModel) => {
			ngModel.$parsers.push((value) => {

                var modifiedInput = value;
                modifiedInput = modifiedInput.replace(/[^0-9]/g, '');

                if(modifiedInput)
                    modifiedInput = parseInt(modifiedInput) + "";

                if (modifiedInput != value) {
                    ngModel.$setViewValue(modifiedInput);
                    ngModel.$render();
                }

                return modifiedInput;
            });
		}
	};
};


// WEBPACK FOOTER //
// ./src/app/common/components/input-number/input-number.directive.js